import React, { useState, useCallback } from "react";
import MultiStepForm from "../pages/multiStep";
import Logo from "../assets/logo-dark.svg";
import Footer from "../components/Footer";
import Loader from "../components/loading";


export default function Home() {
  const [loading, setLoading] = useState(false);
  const isLoading = useCallback((v) => setLoading(v), [loading]);

  return (
    <div>
      {loading && (
        <Loader text="Please hold on while we open your account..." />
      )}

      <div>
        <div className="container">
          <header className="py-5">
            <a className="logo" href="/accountOpening">
              <img src={Logo} alt="ProvidusBank logo" width="150px" />
            </a>
          </header>

          <div className="header">
            <h1 className="intro-tex">ONLINE ACCOUNT OPENING</h1>
            {/* <h3 className="text-muted">Let's get started</h3> */}
          </div>

          
        </div>
        <div className="container mt-5">
          <MultiStepForm loading={isLoading} />
        </div>
      </div>
      <Footer />
    </div>
  );
}
